import React, { FC, useState, useMemo, useCallback, ChangeEvent } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import {
  ILayout,
  ILayout_Render_Context,
} from '@kaidam/fc-shared/src/types/layout'

import {
  getMagicTagDefaults,
} from '@kaidam/fc-shared/src/layout/utils'

import LayoutRender from './LayoutRender'

import {
  LAYOUT_OPTIONS_WIDTH_DEFAULT,
} from '@kaidam/fc-shared/src/constants'

interface StyleProps {
  width?: number,
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  container: ({width}: StyleProps) => ({
    width,
  }),
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  toolbar: {
    flexGrow: 0,
    marginBottom: theme.spacing(2),
  },
  layout: {
    flexGrow: 1,
    '& .Layout-Editor-Cell': {
      border: ['none', '!important'],
    }
  },
}))

interface LayoutPreviewProps {
  data: ILayout,
  context: ILayout_Render_Context,
}

const LayoutPreview: FC<React.PropsWithChildren<LayoutPreviewProps>> = ({
  data,
  context,
}) => {

  const classes = useStyles({
    width: data.options?.width || LAYOUT_OPTIONS_WIDTH_DEFAULT,
  })
  const [ preview, setPreview ] = useState(false)
  const previewData = useMemo(() => {
    return getMagicTagDefaults(data)
  }, [
    data,
  ])

  const useContext = useMemo(() => {
    if(!preview) return context
    return Object.assign({}, context, {
      preview,
      values: previewData,
    })
  }, [
    context,
    previewData,
    preview,
  ])

  const handleTogglePreview = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setPreview(!preview)
  }, [preview])

  return (
    <div className={ classes.root }>
      <div className={ classes.container }>
        <div className={ classes.content }>
          <div className={ classes.toolbar }>
            <FormControlLabel
              control={
                <Switch
                  checked={ preview }
                  onChange={ handleTogglePreview }
                />
              }
              label="View Data?"
            />
          </div>
          <div className={ classes.layout }>
            <LayoutRender
              data={ data }
              context={ useContext }
            />
          </div>
        </div>
      </div>
      
    </div>
    
  )
}

export default LayoutPreview